import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

import employeesData from './employees.mock.json';
import myBranchData from './my-branch.mock.json';
import subdivisionsData from './subdivisions.mock.json';

const mock = new AxiosMockAdapter(instance);
mock
  .onGet(/\/api\/my-branch\/subdivisions.*/)
  .reply(200, subdivisionsData)
  .onGet(/\/api\/my-branch\/employees.*/)
  .reply(200, employeesData)
  .onGet(/\/api\/my-branch.*/)
  .reply(200, myBranchData)
  .onAny()
  .passThrough();
